/**
 * Attempting to parse all locals messages from DOM
 */
export function parseMessages(templateName) {
    if (!templateName) {
        console.warn('Missing template name');
    }
    try {
        const localsAllMessages = JSON.parse(document.getElementById('localsMessages').innerHTML || {});
        return localsAllMessages[templateName] || localsAllMessages;
    } catch (e) {
        console.warn('Please attach locales to DOM');
        return {}
    }
}


// WEBPACK FOOTER //
// ./utilityHelper.js